import { Box, Button, Collapse, Grid, IconButton, TableCellProps, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"

import useAuth from "../../../context/auth"
import { copyToClipboard } from "../../../components/copy"
import { FaCheck, FaRegCopy } from "react-icons/fa6"
import { BiLogoWhatsapp } from "react-icons/bi"
import { PartnerService } from "../../../services/partner"
import { LineComponent } from "../../../components/line"
import { Format } from "../../../utils"
import { TableComponent } from "../../../components/table"

interface IPartner {
    name: string
    cpf: string
    cnpj: string
    id?: number
    createdAt?: string
    pfData: {
        birthday: string
        phone: string
    }
    socialReason: string
    pjData: {
        qsa: Array<{
            nome: string
            qual: string
        }>
        birthday: string
        socialReason: string
        size: string
        situation: string
        address: {
            street: string
            number: string
            city: string
            district: string
            uf: string
            cep: string
        }
        email: string
        phone: string
        cnae: Array<{
            code: string
            isPrincipal: boolean
            text: string
        }>
    }
}

export const PartnerIndication = () => {
    const { user, isMobile, handleModal } = useAuth()
    const { palette } = useTheme()
    const [copied, setCopied] = useState(false)
    const [partners, setPartners] = useState<IPartner[]>([])
    const [loading, setLoading] = useState(false)

    const link = `https://gyroo.com.br/parceiro/cadastro?p=${user?.uuid}`

    const copy = async () => {
        const success = await copyToClipboard(link)

        if (success) {
            setCopied(true)
            handleModal(true, {
                message:
                    <>
                        <Typography>Link copiado com sucesso</Typography>
                        <Typography fontSize={"1.4rem"} mt={"1rem"} fontWeight={400} color="black !important">Envie o link para seus parceiros</Typography>
                    </>,
                type: "success"
            })
        } else {
            handleModal(true, {
                message: "Erro ao copiar código",
                type: "error"
            })
        }
    }

    const shareWhatsApp = () => {
        window.open(`https://wa.me/?text=${link}`, '_blank')
    }

    const list = () => {
        setLoading(true)
        PartnerService.list()
            .then(({ data }) => setPartners(data.partners))
            .finally(() => setLoading(false))
    }

    const MobilePartner = ({ partner }: { partner: IPartner }) => {
        return (
            <Box
                sx={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "10px",
                    boxSizing: "border-box",
                    p: "1.5rem",
                    width: "100%",
                    cursor: "pointer",
                    border: `1px solid ${palette.primary.light}`,
                    display: "flex",
                    flexDirection: "column",
                    gap: ".5rem"
                }}
            >
                <Typography fontSize={"1.4rem"} fontWeight={700} textAlign={"left"}>{partner?.name}</Typography>
                <LineComponent usedInModal height="1px" margin="1rem 1rem" />

                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>ID: </strong>{partner?.id}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>Data da cadastro: </strong>{Format.date(partner?.createdAt)}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>Empresa: </strong>{partner?.pjData?.socialReason}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>CNPJ: </strong>{Format.formatCNPJ(partner?.cnpj)}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>WhatsApp: </strong>{Format.whatsAppNumber(partner?.pfData?.phone)}</Typography>
                {/* <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>UF: </strong>{partner?.pfData?.address?.uf}</Typography>
                <Typography fontSize={"1.4rem"} color="#707070" textAlign={"left"}><strong>Cidade: </strong>{partner?.pfData?.address?.city}</Typography> */}
            </Box>
        )
    }

    const reorderProperties = (array: IPartner[]) => {
        return array.map((item) => ({
            id: item?.id,
            createdAt: item?.createdAt,
            name: item?.name,
            enterprise: item?.pjData.socialReason,
            cnpj: item?.cnpj,
            phone: Format.whatsAppNumber(item?.pfData.phone),
        }))
    }

    useEffect(() => {
        list()
    }, [])


    return (
        <Box
            sx={{
                maxWidth: "150rem",
                width: "100%",
                margin: "0 auto",
                ...(!isMobile && {
                    padding: "0 2rem",
                    width: "auto",
                }),
            }}
        >

            <Typography color="secondary" fontWeight={900} fontSize={"2.8rem"} lineHeight={"3.5rem"}>Indique novos parceiros de vendas</Typography>
            <Typography
                fontSize={"1.6rem"}
                fontWeight={100}
                fontFamily={"Nexa ExtraLight"}
                width={"100%"}
                mt={".5rem"}
                textAlign={"justify"}
                boxSizing={"border-box"}
            >
                Aumente seus ganhos recorrentes ao indicar novos parceiros de vendas! Receba <strong>1% de comissão</strong> sobre todas as vendas geradas por esses parceiros.
            </Typography>

            <Typography
                fontSize={"1.6rem"}
                fontWeight={100}
                fontFamily={"Nexa ExtraLight"}
                width={"100%"}
                mt={"2rem"}
            >
                Copie o link abaixo para convidar novos parceiros e receba <strong>1% de comissão</strong>
            </Typography>
            <Typography sx={{
                opacity: .5,
                maxWidth: "80rem",
                width: "100%",  // Garante que o botão ocupe toda a largura disponível até o valor máximo
                margin: "3rem auto",  // Centraliza horizontalmente
                display: "flex",
                mb: "-3rem",
                fontSize: "1.4rem"
            }}
                onClick={() => copy()}
            >LINK PARA INDICAÇÃO DE NOVOS PARCEIROS</Typography>
            <Grid
                display={"flex"}
                direction={"row"}
                boxSizing={"border-box"}
                gap={"1rem"}
                maxWidth={"80rem"}
                margin={"3rem auto"}
            >

                <Grid
                    onClick={() => copy()}
                    sx={{
                        height: "4.9rem",
                        width: "calc(100% - 4.9rem - 2rem)",
                        border: "1px solid black",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                        pl: ".8rem",
                    }}>
                    <Typography
                        fontSize={"1.4rem"}
                        fontWeight={600}
                        lineHeight={"1.694rem"}
                        width={"100%"}
                        whiteSpace={"nowrap"}
                        overflow={"hidden"}
                        textOverflow={"ellipsis"}
                    >
                        {link}
                    </Typography>
                </Grid>

                <IconButton
                    onClick={() => copy()}
                    sx={{
                        height: "4.9rem",
                        width: "4.9rem",
                        border: "1px solid black",
                        borderRadius: "10px",
                    }}
                >
                    {!copied ? <FaRegCopy size={20} color="#000000" /> : <FaCheck size={20} color="green" />}
                </IconButton>
            </Grid>
            <Typography textAlign={"center"} m={"-2rem 0rem"} sx={{ opacity: .5 }}>ou</Typography>

            <Button
                startIcon={<BiLogoWhatsapp color="white" size={24} />}
                variant="contained"
                sx={{
                    background: "linear-gradient(90deg, #1D22E6 0%, #178BF1 100%)",
                    height: "4.8rem",
                    fontSize: "1.6rem",
                    fontWeight: 600,
                    animation: "pulse 2s infinite",
                    maxWidth: "80rem",
                    width: "100%",  // Garante que o botão ocupe toda a largura disponível até o valor máximo
                    margin: "3rem auto",  // Centraliza horizontalmente
                    display: "flex",
                }}
                onClick={shareWhatsApp}
            >
                Envie o link por WhatsApp
            </Button>

            <LineComponent />

            <Typography fontSize={"2rem"} fontWeight={600} mb={"2rem"}>Parceiros</Typography>

            {!isMobile && <TableComponent
                head={[
                    {
                        label: "ID",
                        placement: "left"
                    },
                    {
                        label: "Data de cadastro",
                        placement: "left"
                    },
                    {
                        label: "Cliente",
                        placement: "left"
                    },
                    {
                        label: "Empresa",
                        placement: "left"
                    },
                    {
                        label: "CNPJ",
                        placement: "left"
                    },
                    {
                        label: "WhatsApp",
                        placement: "left"
                    }
                ]}
                body={reorderProperties(partners).map((row) => {
                    const items: {
                        label: string,
                        placement?: TableCellProps["align"],
                        customized?: JSX.Element
                    }[] = []
                    for (const key of Object.keys(row)) {
                        if (key === "cnpj") {
                            items.push({
                                label: Format.formatCNPJ(row[key])
                            })
                        } else if (key === "createdAt") {
                            items.push({
                                label: Format.dateWithTime(row[key])
                            })
                        } else {
                            items.push({
                                //@ts-ignore
                                label: row[key]?.toString()
                            })
                        }

                    }
                    return items
                })}
                loading={loading}
            />}

            {isMobile &&
                <Collapse in={partners?.length > 0}>
                    <Grid
                        display={"flex"}
                        direction={"column"}
                        gap={"1.5rem"}
                    >
                        {partners.map((p) => <MobilePartner partner={p} />)}
                    </Grid>
                </Collapse>
            }

            {(isMobile && partners?.length === 0) &&
                <Typography textAlign={"center"} sx={{ opacity: .5 }} mt={"2rem"}>Nenhum parceiro encontrado...</Typography>
            }


        </Box>
    )
}